function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types'; // import { timingSafeEqual } from 'crypto';

var ZonaImg = function (_Component) {
  _inherits(ZonaImg, _Component);

  function ZonaImg() {
    var _temp, _this, _ret;

    _classCallCheck(this, ZonaImg);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          zona = _this$props.zona,
          onClick = _this$props.onClick;

      if (zona.activa === 'no') {
        return;
      }

      onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ZonaImg.prototype.render = function render() {
    var _props = this.props,
        left = _props.left,
        top = _props.top,
        width = _props.width,
        height = _props.height,
        clase = _props.clase,
        textoFijo = _props.textoFijo,
        textoExtra = _props.textoExtra,
        zona = _props.zona;
    var style = {
      left: left,
      top: top,
      width: width,
      height: height,
      position: 'absolute'
    };
    var clases = [];
    clase && clases.push(clase); // pruebas rollover por imagen (no funciona porque falta informar ancho y alto)
    // const imagenZonaAux = 'url(contenido/' + zona.id.split('.')[0] + 'b.jpg)'
    // const styleAux = { 'background': imagenZonaAux , 'background-attachment': 'fixed', 'background-position': left + ' ' + top }

    return React.createElement('div', {
      id: zona.id.split('.').join('_'),
      className: clases.join(' '),
      style: style,
      onClick: this.handleClick
    }, textoFijo, React.createElement('span', null, textoExtra));
  };

  return ZonaImg;
}(Component);

ZonaImg.propTypes = process.env.NODE_ENV !== "production" ? {
  left: t.string.isRequired,
  top: t.string.isRequired,
  width: t.string.isRequired,
  height: t.string.isRequired,
  clase: t.string,
  textoFijo: t.string,
  // texto fijo para todos los botones img con el mismo id
  textoExtra: t.string,
  // texto variable que viene de datos
  zona: t.object,
  onClick: t.func.isRequired
} : {};
export default ZonaImg;